import React from 'react';
import { map } from 'lodash-es';
import DoubleRangeInput from '@/components/search/DoubleRangeInput';
import { SearchResultsOption } from '@/lib/search-helpers';
import { VendorFilters } from '@/lib/collections/vendor/vendor-search-helpers';
import FilterGroup from '@/components/collections/FilterGroup';

const UNWANTED_BRANDS = ['?', 'Cobalt', 'OPPO'];

export default function FilterSidebar(
  props: Readonly<{
    handle: string;
    options: Partial<Record<string, SearchResultsOption[]>>;
    query: string | string[] | undefined;
    qs: Record<string, string>;
    priceRange: Record<'min' | 'max', number>;
    onPriceRangeChange: ({ min, max }: { min: number; max: number }) => void;
    id: 'modal' | 'default';
  }>,
) {
  const { handle, options, query, qs, priceRange, onPriceRangeChange, id } =
    props;

  const filterPriority: Partial<Record<string, number>> = {
    categories: 1,
    brand: 2,
  };

  const maxPriority =
    Math.max(
      ...Object.values(filterPriority).filter(
        (value): value is number => value !== undefined,
      ),
    ) + 1;

  // As the category acts as a dynamic filter, it might result in the removal of other options. To address this, we aim to display the selected options that disappear due to the category selection. This way, users will understand why there's no match
  const handleOptions = (
    key: string,
    filterOptions:
      | {
          key: string;
          count: number;
        }[]
      | undefined,
  ) => {
    if (!filterOptions) return [];
    const selectedQs = qs[key]
      ? qs[key]
          .split('|')
          .filter((q) => !map(filterOptions, 'key').includes(q))
          .map((q) => ({ key: q, count: 1 }))
      : [];

    return [...filterOptions, ...selectedQs];
  };

  return (
    <div className="group grid" key={handle}>
      <div className="border-b px-3 pt-3">
        <DoubleRangeInput
          key={query?.toString()} // When query changes, we reset the search
          range={priceRange}
          values={{
            max: Number(qs.maxPrice),
            min: 0,
          }}
          onChange={onPriceRangeChange}
          id={id}
        />
      </div>
      {Object.keys(options)
        .sort(
          (a, b) =>
            (filterPriority[a] ?? maxPriority) -
            (filterPriority[b] ?? maxPriority),
        ) // Sort Filters By Priority
        .map((key) => {
          const filter = options[key as VendorFilters]?.filter(
            (o) => !UNWANTED_BRANDS.includes(o.key),
          );

          if (
            filter != null &&
            (filter.length > 1 || (filter.length > 0 && qs[key]))
          ) {
            return (
              <FilterGroup
                name={key as VendorFilters}
                key={key}
                values={handleOptions(key, filter)}
              />
            );
          }

          return null;
        })}
    </div>
  );
}
